import React, {Component} from 'react'
import {connect} from 'react-redux'
import {
	Route,
	Redirect,
	Switch,
	withRouter
} from 'react-router-dom'

import Layout from './containers/Layout/Layout'
import Submit from './containers/Submit/Submit'
import UrlList from './containers/UrlList/UrlList'
import AccountList from './containers/AccountList/AccountList'

import {getPageUrl} from './utils/utils'
import * as pagesConfig from './config/pages'

class App extends Component {
	render() {
		return (
			<Layout {...this.props}>
				<Switch>
					<Route
						exact
						path={getPageUrl(pagesConfig.SUBMIT_PAGE)}
						component={Submit}
					/>
					<Route
						path={getPageUrl(pagesConfig.URL_LIST_PAGE)}
						component={UrlList}
					/>
					{
						this.props.showHiddenPage
						? <Route
							path={getPageUrl(pagesConfig.ACCOUNT_LIST_PAGE)}
							component={AccountList}
						/>
						: null
					}
					<Redirect
						to={getPageUrl(pagesConfig.SUBMIT_PAGE)}
					/>
				</Switch>
			</Layout>
		)
	}
}

const mapStateToProps = state => ({
	showHiddenPage: state.navigation.showHiddenPage,
})

export default withRouter(connect(mapStateToProps)(App))